import {styled, Typography} from '@innowise-group/ui-kit';

export const FloorPlanContainer = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 0;
`;

export const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;
`;

export const MutationOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
  border-radius: 0 0 6px 6px;
  pointer-events: all;

  & > * {
    margin: 0 !important;
  }
`;

export const ReactFlowWrapper = styled.div<{selectable: boolean; focus: boolean; screenZoom: number}>`
  width: 100%;
  height: 100%;
  border: 2px solid ${({theme, focus}) => (focus ? theme.palette.general.smart : theme.palette.general.lightGrey[60])};
  box-sizing: border-box;
  border-radius: 0 0 6px 6px;
  cursor: ${({selectable}) => (!selectable ? 'grab' : 'default')};
  padding: 3px;
  zoom: ${({screenZoom}) => 1 / screenZoom};

  & .react-flow__controls {
    width: 32px;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    left: 24px;
    bottom: 24px;

    & .react-flow__controls-button {
      width: 100%;
      height: 32px;
      margin: 0;
      padding: 0;
      box-sizing: border-box;

      & svg {
        width: 16px;
        height: 16px;
        max-width: 16px;
        max-height: 16px;
      }
    }
  }
`;

export const Address = styled(Typography)`
  font-size: 18px;
  position: absolute;
`;
